import * as React from 'react'

import { TContrastLevel } from '~theme/typings'
import { GridRow } from '~ui/components/layout/Box'
import { SpeedloLogo } from '~ui/components/media/Svg/components/SpeedloLogo'
import { Svg } from '~ui/components/media/Svg/Svg'
import { Text } from '~ui/components/typography/Text/Text'

type TProps = NoChildren & {
  /**
   * translated text next to the speedlo logo
   */
  speedloFooterLabel: React.ReactNode
  /**
   * footer padding
   */
  padding?: PropsOf<typeof GridRow>['padding']
}
const contrast: TContrastLevel = `low`

/**
 * low-contrasted footer content with text & speedlo logo
 */
export const SpeedloFooter: React.FC<TProps> = ({ padding, speedloFooterLabel }) => {
  return (
    <GridRow padding={padding} gap={`small`} placeItems={`center`}>
      <Text fontSize={`s12`} contrast={contrast}>
        {speedloFooterLabel}
      </Text>
      <Svg component={SpeedloLogo} height={`1rem`} contrast={contrast} />
    </GridRow>
  )
}
